import {lazy} from '@aboutyou/lazy-imports';
export const Sizes = lazy(() =>
  import('./Sizes.eager').then(mod => ({default: mod.Sizes})),
);
